import { EscregSDK } from '@d13co/escreg-sdk';

// The default Fnet-deployed Escreg registry indexes app escrows for ALL
// Algorand networks (mainnet, testnet, fnet, betanet), so a single default
// instance serves whichever network the app is configured for.
const sdk = new EscregSDK({});

// Batched escrow lookup. Escreg imposes no batch-size limit: it chunks the
// addresses internally (128 per simulate call) and runs the chunks in parallel,
// so we hand it every address at once instead of looking them up one by one.
// Returns a map of address -> owning app ID (bigint), or undefined per address
// when it is not a registered app escrow.
export default async function lookupEscrows(addresses) {
  if (!addresses.length) return {};
  const t0 = performance.now();
  try {
    const result = await sdk.lookup({ addresses, concurrency: 8 });
    const ms = Math.round(performance.now() - t0);
    const hits = Object.values(result).filter(Boolean).length;
    console.log(`escreg lookup: ${addresses.length} addrs -> ${hits} escrows in ${ms}ms`);
    return result;
  } catch (e) {
    const ms = Math.round(performance.now() - t0);
    console.error(`escreg lookup failed after ${ms}ms (${addresses.length} addrs)`, e);
    return {};
  }
}
